/**
 * dsh-widgets — GENERATED widget registry. DO NOT EDIT BY HAND.
 *
 * Produced by scripts/gen-registry.mjs from the unit dirs under src/widgets/
 * (the machine-readable part comes from each unit's manifest.json; the
 * descriptors come from each unit's index.ts) AND from the data-source adapters
 * under src/client/families/<id>/adapter.ts. Regenerate with:
 *   pnpm gen:registry        (write)
 *   pnpm check:registry      (verify up-to-date — the build/CI guard)
 *
 * Adding a widget = creating one unit dir; adding a data source = creating one
 * family adapter file. The registry follows automatically.
 */

import w_counts from '../widgets/counts'
import w_llm from '../widgets/llm'
import w_tool from '../widgets/tool'
import w_ttft from '../widgets/ttft'
import w_tps from '../widgets/tps'
import w_cache from '../widgets/cache'
import w_tokens from '../widgets/tokens'
import w_context from '../widgets/context'
import w_context_water from '../widgets/context-water'
import w_task from '../widgets/task'
import w_trajectory from '../widgets/trajectory'
import w_harness_board from '../widgets/harness-board'
import w_quote from '../widgets/quote'
import w_clock from '../widgets/clock'
import w_calendar from '../widgets/calendar'
import w_task_timer from '../widgets/task-timer'
import w_stopwatch from '../widgets/stopwatch'
import w_countdown from '../widgets/countdown'
import w_heatmap from '../widgets/heatmap'
import w_heatmap_bars from '../widgets/heatmap-bars'
import w_quota_manage from '../widgets/quota-manage'
import w_usage_bars from '../widgets/usage-bars'
import w_usage_rings from '../widgets/usage-rings'
import w_usage_rolling from '../widgets/usage-rolling'
import w_usage_weekly from '../widgets/usage-weekly'
import w_usage_monthly from '../widgets/usage-monthly'
import w_cc_whoami from '../widgets/cc-whoami'
import w_peak_pricing from '../widgets/peak-pricing'
import w_sys_cpu from '../widgets/sys-cpu'
import w_cc_usage from '../widgets/cc-usage'
import w_sys_gpu from '../widgets/sys-gpu'
import w_cc_credits from '../widgets/cc-credits'
import w_sys_rings from '../widgets/sys-rings'
import w_cc_windows from '../widgets/cc-windows'
import w_sys_board from '../widgets/sys-board'
import w_cc_subscription from '../widgets/cc-subscription'
import w_sys_gpu_line from '../widgets/sys-gpu-line'
import w_cc_window_5h from '../widgets/cc-window-5h'
import w_cc_window_weekly from '../widgets/cc-window-weekly'
import w_cc_window_monthly from '../widgets/cc-window-monthly'
import w_deepseek_balance from '../widgets/deepseek-balance'
import w_github_contrib from '../widgets/github-contrib'
import w_github_stars from '../widgets/github-stars'
import w_github_issues from '../widgets/github-issues'
import w_github_push from '../widgets/github-push'
import w_github_board from '../widgets/github-board'
import w_usage_mix from '../widgets/usage-mix'
import w_trajectory_stats from '../widgets/trajectory-stats'
import w_peak_pricing_board from '../widgets/peak-pricing-board'
import w_goal_progress from '../widgets/goal-progress'
import w_subagent from '../widgets/subagent'
import w_guard from '../widgets/guard'
import w_jobs from '../widgets/jobs'
import w_sys_disk from '../widgets/sys-disk'
import w_window_forecast from '../widgets/window-forecast'
import w_sys_net from '../widgets/sys-net'
import w_sys_power from '../widgets/sys-power'
import w_sys_procs from '../widgets/sys-procs'
import w_sys_services from '../widgets/sys-services'
import w_session_cost from '../widgets/session-cost'
import w_github_notify from '../widgets/github-notify'
import * as src_cc from './families/cc/adapter'
import * as src_deepseek from './families/deepseek/adapter'
import * as src_github from './families/github/adapter'
import * as src_pricing from './families/pricing/adapter'
import * as src_sys from './families/sys/adapter'
import * as src_usage from './families/usage/adapter'
import { isSourceAdapter } from './data/source-contract'

/** Every discovered widget, in manifest display order (then by id). */
export const WIDGETS: import('./lib/contract/types').Widget[] = [
  w_counts,
  w_llm,
  w_tool,
  w_ttft,
  w_tps,
  w_cache,
  w_tokens,
  w_context,
  w_context_water,
  w_task,
  w_trajectory,
  w_harness_board,
  w_quote,
  w_clock,
  w_calendar,
  w_task_timer,
  w_stopwatch,
  w_countdown,
  w_heatmap,
  w_heatmap_bars,
  w_quota_manage,
  w_usage_bars,
  w_usage_rings,
  w_usage_rolling,
  w_usage_weekly,
  w_usage_monthly,
  w_cc_whoami,
  w_peak_pricing,
  w_sys_cpu,
  w_cc_usage,
  w_sys_gpu,
  w_cc_credits,
  w_sys_rings,
  w_cc_windows,
  w_sys_board,
  w_cc_subscription,
  w_sys_gpu_line,
  w_cc_window_5h,
  w_cc_window_weekly,
  w_cc_window_monthly,
  w_deepseek_balance,
  w_github_contrib,
  w_github_stars,
  w_github_issues,
  w_github_push,
  w_github_board,
  w_usage_mix,
  w_trajectory_stats,
  w_peak_pricing_board,
  w_goal_progress,
  w_subagent,
  w_guard,
  w_jobs,
  w_sys_disk,
  w_window_forecast,
  w_sys_net,
  w_sys_power,
  w_sys_procs,
  w_sys_services,
  w_session_cost,
  w_github_notify,
]

/**
 * Every discovered DATA SOURCE ADAPTER, in family-path order.
 *
 * This is what makes `manifest.source` a free string: the set of legal ids comes
 * from the family directories themselves, so a manifest can only name a source
 * that actually exists (`pnpm check:registry` fails otherwise) and adding one
 * never edits a shared file. See src/client/data/source-contract.ts.
 */
export const SOURCE_ADAPTERS: import('./data/source-contract').SourceAdapter[] = [
  src_cc,
  src_deepseek,
  src_github,
  src_pricing,
  src_sys,
  src_usage,
]
  .flatMap((mod) => Object.values(mod))
  .filter(isSourceAdapter)
  // A family module's namespace also carries its `default` (the same object as
  // one of its named exports), so the id — not the reference — decides identity:
  // one adapter, one registration, one poller.
  .filter((a, i, all) => all.findIndex((x) => x.id === a.id) === i)

/**
 * Per-widget RUNTIME metadata, generated from each unit's manifest.json.
 *
 * WHAT vs HOW: a manifest declares what the widget IS — which live data source it
 * waits on, and what its body looks like while that source is still in flight.
 * The SHELL decides HOW that becomes a loading card, because a widget cannot tell
 * "my source is still in flight" from "my source answered with nothing", and
 * those two states deserve different cards (placeholder pills vs an honest
 * empty state).
 *
 * Declaring it in the manifest is what keeps a new widget unit to ONE directory:
 * there is no central id→source map to edit, and `check:registry` fails the build
 * when a manifest drifts from the generated file.
 */
export const WIDGET_RUNTIME: Record<string, import('./lib/contract/types').WidgetRuntimeMeta> = {
  "calendar": { reads: ["schedule"] },
  "countdown": { reads: ["schedule"] },
  "quota-manage": { source: "cc", skeleton: { shape: "figures", count: 2 } },
  "usage-bars": { source: "usage", skeleton: { shape: "bars" } },
  "usage-rings": { source: "usage", skeleton: { shape: "rings", count: 3 } },
  "usage-rolling": { source: "usage", skeleton: { shape: "text" } },
  "usage-weekly": { source: "usage", skeleton: { shape: "text" } },
  "usage-monthly": { source: "usage", skeleton: { shape: "text" } },
  "cc-whoami": { source: "cc", skeleton: { shape: "text" } },
  "sys-cpu": { source: "sys", skeleton: { shape: "text" } },
  "cc-usage": { source: "cc", skeleton: { shape: "figures", count: 3 } },
  "sys-gpu": { source: "sys", skeleton: { shape: "text" } },
  "cc-credits": { source: "cc", skeleton: { shape: "quotas", count: 3 } },
  "sys-rings": { source: "sys", skeleton: { shape: "rings", count: 2 } },
  "cc-windows": { source: "cc", skeleton: { shape: "rings", count: 3 } },
  "sys-board": { source: "sys", skeleton: { shape: "rings", count: 4 } },
  "cc-subscription": { source: "cc", skeleton: { shape: "text" } },
  "sys-gpu-line": { source: "sys", skeleton: { shape: "line" } },
  "cc-window-5h": { source: "cc", skeleton: { shape: "text" } },
  "cc-window-weekly": { source: "cc", skeleton: { shape: "text" } },
  "cc-window-monthly": { source: "cc", skeleton: { shape: "text" } },
  "deepseek-balance": { source: "deepseek", skeleton: { shape: "text", rows: 3 } },
  "github-contrib": { source: "github", skeleton: { shape: "heatmap" } },
  "github-stars": { source: "github", skeleton: { shape: "text" } },
  "github-issues": { source: "github", skeleton: { shape: "text" } },
  "github-push": { source: "github", skeleton: { shape: "text" } },
  "github-board": { source: "github", skeleton: { shape: "figures", count: 4 } },
  "usage-mix": { source: "cc", skeleton: { shape: "rings", count: 1 } },
  "sys-disk": { source: "sys", skeleton: { shape: "quotas", count: 3 } },
  "window-forecast": { source: "cc", skeleton: { shape: "quotas" } },
  "sys-net": { source: "sys", skeleton: { shape: "text" } },
  "sys-power": { source: "sys", skeleton: { shape: "text" } },
  "sys-procs": { source: "sys", skeleton: { shape: "bars" } },
  "sys-services": { source: "sys", skeleton: { shape: "quotas", count: 1 } },
  "session-cost": { source: "cc", skeleton: { shape: "text" } },
  "github-notify": { source: "github", skeleton: { shape: "text" } },
}

/** All widget ids, in registry order. */
export const ALL_IDS: string[] = [
  'counts',
  'llm',
  'tool',
  'ttft',
  'tps',
  'cache',
  'tokens',
  'context',
  'context-water',
  'task',
  'trajectory',
  'harness-board',
  'quote',
  'clock',
  'calendar',
  'task-timer',
  'stopwatch',
  'countdown',
  'heatmap',
  'heatmap-bars',
  'quota-manage',
  'usage-bars',
  'usage-rings',
  'usage-rolling',
  'usage-weekly',
  'usage-monthly',
  'cc-whoami',
  'peak-pricing',
  'sys-cpu',
  'cc-usage',
  'sys-gpu',
  'cc-credits',
  'sys-rings',
  'cc-windows',
  'sys-board',
  'cc-subscription',
  'sys-gpu-line',
  'cc-window-5h',
  'cc-window-weekly',
  'cc-window-monthly',
  'deepseek-balance',
  'github-contrib',
  'github-stars',
  'github-issues',
  'github-push',
  'github-board',
  'usage-mix',
  'trajectory-stats',
  'peak-pricing-board',
  'goal-progress',
  'subagent',
  'guard',
  'jobs',
  'sys-disk',
  'window-forecast',
  'sys-net',
  'sys-power',
  'sys-procs',
  'sys-services',
  'session-cost',
  'github-notify',
]

/** Every valid instance key (each widget at each of its supported sizes). */
export const ALL_INSTANCES: string[] = [
  `counts@2x2`,
  `llm@2x2`,
  `tool@2x2`,
  `ttft@2x2`,
  `tps@2x2`,
  `cache@2x2`,
  `tokens@2x2`,
  `context@2x2`,
  `context-water@2x2`,
  `context-water@2x4`,
  `task@2x2`,
  `task@2x4`,
  `trajectory@2x2`,
  `harness-board@2x4`,
  `quote@2x2`,
  `clock@2x2`,
  `calendar@2x2`,
  `calendar@2x4`,
  `task-timer@2x2`,
  `task-timer@2x4`,
  `stopwatch@2x2`,
  `countdown@2x2`,
  `heatmap@2x2`,
  `heatmap@2x4`,
  `heatmap-bars@2x2`,
  `heatmap-bars@2x4`,
  `quota-manage@2x2`,
  `usage-bars@2x2`,
  `usage-rings@2x2`,
  `usage-rolling@2x2`,
  `usage-weekly@2x2`,
  `usage-monthly@2x2`,
  `cc-whoami@2x2`,
  `peak-pricing@2x2`,
  `sys-cpu@2x2`,
  `cc-usage@2x2`,
  `sys-gpu@2x2`,
  `cc-credits@2x2`,
  `sys-rings@2x2`,
  `cc-windows@2x2`,
  `sys-board@2x4`,
  `cc-subscription@2x2`,
  `sys-gpu-line@2x2`,
  `cc-window-5h@2x2`,
  `cc-window-weekly@2x2`,
  `cc-window-monthly@2x2`,
  `deepseek-balance@2x2`,
  `github-contrib@2x2`,
  `github-contrib@2x4`,
  `github-stars@2x2`,
  `github-issues@2x2`,
  `github-push@2x2`,
  `github-board@2x4`,
  `usage-mix@2x2`,
  `trajectory-stats@2x2`,
  `peak-pricing-board@2x4`,
  `goal-progress@2x2`,
  `subagent@2x2`,
  `guard@2x2`,
  `jobs@2x2`,
  `sys-disk@2x4`,
  `window-forecast@2x2`,
  `sys-net@2x2`,
  `sys-power@2x2`,
  `sys-procs@2x2`,
  `sys-services@2x2`,
  `session-cost@2x2`,
  `github-notify@2x2`,
]

/** The stats-line family (fresh installs pre-load ONLY these). */
export const STATS_WIDGET_IDS: string[] = [
  'counts',
  'llm',
  'tool',
  'ttft',
  'tps',
  'cache',
  'tokens',
]

/** The default installed set: the stats-line family at 2×2. */
export const DEFAULT_INSTALLED: string[] = [
  `counts@2x2`,
  `llm@2x2`,
  `tool@2x2`,
  `ttft@2x2`,
  `tps@2x2`,
  `cache@2x2`,
  `tokens@2x2`,
]

/** Merged per-widget dictionaries (family-shared + every unit's locale).
 *  Registered with the locale service at apply() time. */
export const WIDGET_LOCALES: { zh: Record<string, string>; en: Record<string, string> } = {
  zh: {
    "usage.title": "OpenCode 用量",
    "usage.totalKey": "总 Key",
    "usage.cycleHint": "单击循环：{chain}",
    "usage.resets": "重置 {date}",
    "usage.rolling": "滚动",
    "usage.week": "周",
    "usage.month": "月",
    "group.commandcode": "Command Code",
    "group.deepseek": "DeepSeek 官方",
    "cc.notConfigured": "未配置 COMMANDCODE_API_KEY（host 自动读取环境变量 / 凭据，无需手动填写）",
    "cc.unconfigured": "未配置 COMMANDCODE_API_KEY — host 自动读取环境变量 / $DSH_HOME/.credentials.yaml / .env，重启后自动生效",
    "cc.unloaded": "dsh web 未重启，等待 host 路由加载（重启后自动刷新）",
    "cc.unavailable": "Command Code 服务暂不可用",
    "cc.account": "账户身份",
    "cc.tokens": "tokens",
    "cc.requests": "请求",
    "cc.successRate": "成功率",
    "cc.spend": "消费",
    "cc.credits": "credits",
    "cc.free": "免费",
    "cc.purchased": "购买",
    "cc.fiveHour": "5h",
    "cc.weekly": "周",
    "cc.periodEnd": "账期至",
    "cc.period": "账期 {m}-{d}",
    "cc.title": "Command Code",
    "cc.roleUsage": "账期用量",
    "cc.roleCredits": "额度",
    "cc.roleWindow": "用量环形图",
    "cc.roleAccount": "账户",
    "cc.win5h": "5 小时窗口",
    "cc.winWeekly": "周窗口",
    "cc.winMonthly": "月窗口",
    "cc.limit5h": "5 小时限额",
    "cc.limitWeek": "周限额",
    "cc.limitMonth": "月限额",
    "cc.resets": "重置",
    "cc.cancelAtEnd": "到期不续订",
    "cc.cycleHint": "单击切换账户：{chain}",
    "sysinfo.cpu": "CPU",
    "sysinfo.gpu": "GPU",
    "sysinfo.mem": "内存",
    "sysinfo.vram": "显存",
    "sysinfo.memSub": "内存 {used} / {total}",
    "sysinfo.interval": "刷新间隔",
    "sysinfo.intervalCustom": "自定义",
    "sysinfo.intervalCustomValue": "自定义间隔（秒）",
    "sysinfo.noGpu": "未检测到 NVIDIA GPU",
    "sysinfo.waiting": "等待设备数据…",
    "sysinfo.bigMetric": "大数值显示",
    "sysinfo.bigVram": "显存 (GB)",
    "sysinfo.bigTemp": "温度 (°C)",
    "sysinfo.bigUtil": "利用率 (%)",
    "sysinfo.bigMem": "内存 (GB)",
    "sysinfo.bigHint": "点击切换大数值：{chain}",
    "sysinfo.points": "折线采样数",
    "group.github": "GitHub",
    "config.github.user": "GitHub 用户名",
    "config.github.repos": "监控仓库（owner/name，逗号分隔，最多 4 个）",
    "config.github.hint": "留空 = 用本机已登录的 GitHub 账号（凭据 / gh CLI）",
    "github.staleHost": "host 路由未加载 — 重启 dsh web 后自动生效",
    "github.unavailable": "GitHub 暂不可用",
    "github.noUser": "未登录 GitHub — 配置用户名或 token 后可用",
    "github.noRepo": "未取到仓库 — 配置 owner/name 或登录 GitHub",
    "github.cycle": "单击切换仓库：{chain}",
    "github.stars": "Stars",
    "github.forks": "Forks",
    "github.issues": "未关闭 Issue",
    "github.unanswered": "回复",
    "github.unansweredUnknown": "回复（配置 token 后可测）",
    "github.push": "最近提交",
    "github.release": "Release {tag}",
    "github.noRelease": "暂无 Release",
    "github.contrib.total": "{n} 次贡献",
    "github.contrib.unit": "次贡献",
    "github.contrib.title": "提交热度图",
    "github.board.title": "仓库脉搏",
    "github.contrib.windowYear": "近一年",
    "github.contrib.windowQuarter": "近 3 个月",
    "tz.local": "本地",
    "tz.beijing": "北京",
    "tz.tokyo": "东京",
    "tz.london": "伦敦",
    "tz.newyork": "纽约",
    "tz.utc": "UTC",
    "widget.counts.name": "轮次·步数",
    "widget.counts.desc": "本轮会话的轮次与步骤计数",
    "card.counts.value": "{turns}轮 {steps}步",
    "widget.llm.name": "LLM 时长",
    "widget.llm.desc": "模型推理累计耗时",
    "widget.tool.name": "工具调用",
    "widget.tool.desc": "明细三行（默认 失败 / 平均每次 / 工具耗时占比），大字为累计耗时；行可在组件配置里更换",
    "card.tool.running": "正在执行",
    "card.tool.slowest": "最慢",
    "card.tool.failed": "失败",
    "card.tool.mean": "平均每次",
    "card.tool.share": "工具耗时占比",
    "card.tool.calls": "{n} 次 · {m} 个工具",
    "card.tool.hint": "最多 {max} 行 · 拖动整行排序：上面的先显示在卡片上",
    "widget.ttft.name": "首 token 延迟",
    "widget.ttft.desc": "平均首 token 延迟",
    "widget.tps.name": "解码速率",
    "widget.tps.desc": "解码吞吐速度",
    "widget.cache.name": "缓存命中",
    "widget.cache.desc": "缓存命中率环图与本次会话的 token 构成",
    "card.cache.unit": "tok",
    "card.cache.uncached": "未缓存输入",
    "card.cache.read": "缓存读取",
    "card.cache.output": "输出",
    "widget.tokens.name": "会话 Token",
    "widget.tokens.desc": "本次会话的 token 总量与输入 / 输出构成（会话内口径，不是逐日跨会话的用量）",
    "card.tokens.input": "输入",
    "card.tokens.output": "输出",
    "widget.context.name": "上下文压缩",
    "widget.context.desc": "上下文占用百分比 + 右上角按钮两次点击执行压缩；下方是压缩次数 / 累计回收 / 折叠项数",
    "card.context.title": "上下文压缩",
    "card.context.waiting": "等待上下文数据",
    "card.context.compact": "压缩",
    "card.context.confirm": "确认",
    "card.context.folds": "压缩次数",
    "card.context.reclaimed": "累计回收",
    "card.context.items": "折叠项数",
    "card.context.recent": "最近 {ago} 前",
    "widget.context-water.name": "上下文水位",
    "widget.context-water.desc": "上下文系统/工具/消息占比分段条",
    "card.contextWater.title": "上下文已用",
    "card.contextWater.system": "系统提示词",
    "card.contextWater.tools": "工具",
    "card.contextWater.messages": "对话消息",
    "widget.task.name": "任务",
    "widget.task.desc": "任务条目明细：大字为进行中数量（右侧灰字是进行中 / 待办计数），下方按进行中优先列出条目本身，最多 4 行；没有任务时显示「暂无任务」",
    "card.task.small": "进行中 · {pending} 待办",
    "card.task.doing": "进行中",
    "card.task.pending": "待办",
    "card.task.done": "已完成",
    "card.task.none": "暂无任务",
    "widget.task.simToggle": "切换 无任务 / 有任务 预览",
    "widget.trajectory.name": "对话轨迹",
    "widget.trajectory.desc": "官方「轨迹」三色泳道的卡片版：输入 / 模型 / 工具 每次触发一根色条，随模型调用工具实时右移滚动",
    "card.trajectory.legend": "输入 {input}  模型 {model}  工具 {tool}",
    "card.trajectory.input": "输入",
    "card.trajectory.model": "模型",
    "card.trajectory.tool": "工具",
    "config.laneSizing": "泳道宽度",
    "config.laneSizing.time": "按时长",
    "config.laneSizing.equal": "等宽",
    "widget.harness-board.name": "会话概览",
    "widget.harness-board.desc": "把输入框底部那条统计拆出来的会话数字并成一张 2×4：默认 轮次 / LLM / 工具 / 速率，最多 10 个，在组件配置里勾选 + 拖动整行排序（每行最多 5 个、超过自动折成两行；单张 2×2 卡的数字是 20px，这里是 13px——看板用来扫一排，单卡用来看一个）",
    "metric.turns": "轮次",
    "metric.steps": "步数",
    "metric.llm": "LLM",
    "metric.tool": "工具",
    "metric.ttft": "TTFT",
    "metric.tps": "速率",
    "metric.cache": "缓存",
    "metric.in": "输入",
    "metric.out": "输出",
    "metric.context": "上下文",
    "metric.todoDoing": "进行",
    "metric.todoPending": "待办",
    "metric.toolFail": "失败",
    "metric.folds": "折叠",
    "metric.reclaimed": "回收",
    "metric.running": "执行",
    "widget.quote.name": "今日寄语",
    "widget.quote.desc": "显示你自定义的一句话（未填写文本时不显示内容）",
    "card.quote.title": "今日寄语",
    "config.quoteText": "寄语内容",
    "config.showTitle": "显示标题",
    "config.align": "水平对齐",
    "config.valign": "垂直位置",
    "config.wrap": "允许换行",
    "quote.previewPlaceholder": "（填写寄语内容后显示）",
    "group.clock": "时钟",
    "widget.clock.name": "时钟",
    "widget.clock.desc": "指针或数字时钟，可选出时区（本地 / 北京 / 东京 / 伦敦 / 纽约 / UTC）与秒针；秒针每秒走一格",
    "card.clock.face": "表盘样式",
    "card.clock.faceAnalog": "指针表盘",
    "card.clock.faceDigital": "数字显示",
    "card.clock.timeZone": "时区",
    "card.clock.showLabel": "显示时区标签",
    "card.clock.seconds": "显示秒针",
    "card.clock.h24": "24 小时制",
    "card.clock.am": "上午",
    "card.clock.pm": "下午",
    "card.clock.md": "{m}月{d}日",
    "card.clock.weekday.0": "周日",
    "card.clock.weekday.1": "周一",
    "card.clock.weekday.2": "周二",
    "card.clock.weekday.3": "周三",
    "card.clock.weekday.4": "周四",
    "card.clock.weekday.5": "周五",
    "card.clock.weekday.6": "周六",
    "group.calendar": "日历",
    "widget.calendar.name": "日历",
    "widget.calendar.desc": "本月月历：今日高亮，周末或法定节假日染色，可切换周一开始 / 周日开始（时区决定「今天」是哪天）；有 DSH 定时任务的日子打点，2×4 右侧列出临近日程（没有定时任务子系统时退回纯月历）",
    "card.calendar.timeZone": "时区",
    "card.calendar.weekStart": "每周起始",
    "card.calendar.weekStartMonday": "周一开始",
    "card.calendar.weekStartSunday": "周日开始",
    "card.calendar.tint": "染色规则",
    "card.calendar.tintWeekend": "周末",
    "card.calendar.tintHoliday": "法定节假日",
    "card.calendar.tintNone": "不染色",
    "card.calendar.showOther": "显示相邻月份",
    "card.calendar.agenda": "临近日程",
    "card.calendar.agendaEmpty": "近期无日程",
    "card.calendar.nextHint": "下一件 {title} · 还有 {left}",
    "card.calendar.whenToday": "今天 {time}",
    "card.calendar.whenDate": "{m}/{d} {time}",
    "card.calendar.monthLabel": "{y}年{month}",
    "card.calendar.month.1": "1月",
    "card.calendar.month.2": "2月",
    "card.calendar.month.3": "3月",
    "card.calendar.month.4": "4月",
    "card.calendar.month.5": "5月",
    "card.calendar.month.6": "6月",
    "card.calendar.month.7": "7月",
    "card.calendar.month.8": "8月",
    "card.calendar.month.9": "9月",
    "card.calendar.month.10": "10月",
    "card.calendar.month.11": "11月",
    "card.calendar.month.12": "12月",
    "card.calendar.weekday.0": "日",
    "card.calendar.weekday.1": "一",
    "card.calendar.weekday.2": "二",
    "card.calendar.weekday.3": "三",
    "card.calendar.weekday.4": "四",
    "card.calendar.weekday.5": "五",
    "card.calendar.weekday.6": "六",
    "card.calendar.holidayStale": "法定节假日表还没有录入 {y} 年：本月只按周末染色",
    "group.time": "时间",
    "widget.task-timer.name": "任务计时",
    "widget.task-timer.desc": "本回合已运行多久，以及它此刻在等什么（工具调用 / 模型步）：数字来自本会话既有投影，回合运行中每秒推进，无 open turn 时显示「空闲」",
    "card.task-timer.title": "任务计时",
    "card.task-timer.idle": "空闲",
    "card.task-timer.running": "计时中",
    "card.task-timer.labelTurn": "本回合",
    "card.task-timer.labelTool": "当前工具",
    "card.task-timer.labelModel": "模型",
    "card.task-timer.labelTools": "工具",
    "card.task-timer.labelCalls": "本会话轮次",
    "card.task-timer.labelSteps": "本会话步数",
    "card.task-timer.toolCount": "{n} 个并行",
    "card.task-timer.simToggle": "切换预览状态",
    "widget.stopwatch.name": "秒表",
    "widget.stopwatch.desc": "可交互正计时秒表：开始 / 暂停 / 继续 / 复位，读数每秒自己走，状态存在实例配置里（刷新、换浏览器都不丢）",
    "widget.stopwatch.simToggle": "切换 未开始 / 计时中 / 已暂停 预览",
    "card.stopwatch.title": "秒表",
    "card.stopwatch.ready": "未开始",
    "card.stopwatch.running": "计时中",
    "card.stopwatch.paused": "已暂停 · 已计 {t}",
    "card.stopwatch.start": "开始",
    "card.stopwatch.resume": "继续",
    "card.stopwatch.pause": "暂停",
    "card.stopwatch.reset": "复位",
    "widget.countdown.name": "倒计时",
    "widget.countdown.desc": "先点时长胶囊（1/3/5/10 分钟，可在配置里自定义一档）开始倒计时；运行界面与秒表同款，左上角箭头返回；也可以切换成盯住最近的 DSH 定时任务还剩多久",
    "widget.countdown.simToggle": "切换 胶囊/自定义/暂停/计时/时间到/定时任务 预览",
    "card.countdown.title": "倒计时",
    "card.countdown.back": "返回",
    "card.countdown.mode": "倒计时目标",
    "card.countdown.mode.pick": "时长胶囊",
    "card.countdown.mode.next": "最近的定时任务",
    "card.countdown.unitMin": "分钟",
    "card.countdown.custom": "自定义分钟数",
    "card.countdown.customHint": "填 1–1440 的整数：它会占据最长的那一格（10 分钟位），留空则四格固定为 1/3/5/10",
    "card.countdown.done": "时间到",
    "card.countdown.noSchedule": "暂无日程",
    "card.countdown.unavailable": "定时任务不可用",
    "card.countdown.start": "开始",
    "card.countdown.resume": "继续",
    "card.countdown.pause": "暂停",
    "card.countdown.reset": "复位",
    "card.countdown.rule.every": "每 {d}",
    "card.countdown.rule.daily": "每天 {time}",
    "card.countdown.rule.weekly": "每周 {d}",
    "card.countdown.rule.cron": "{expr}",
    "card.countdown.rule.once": "一次性",
    "card.countdown.dow.1": "一",
    "card.countdown.dow.2": "二",
    "card.countdown.dow.3": "三",
    "card.countdown.dow.4": "四",
    "card.countdown.dow.5": "五",
    "card.countdown.dow.6": "六",
    "card.countdown.dow.7": "日",
    "widget.heatmap.name": "Token 热度图",
    "widget.heatmap.desc": "每日 Token 用量热度图（自记账）。2×2 显示近 3 个月日历，2×4 显示近半年全部用量点；大小可在市场左右切换",
    "card.heatmap.title": "Token 用量",
    "config.monthMode": "窗口对齐方式",
    "config.monthMode.rolling": "滚动(今天最右)",
    "config.monthMode.quarter": "季度对齐",
    "config.timeZone": "记账时区",
    "config.timeZone.beijing": "北京 (UTC+8)",
    "config.timeZone.local": "跟随系统",
    "widget.heatmap-bars.name": "Token 柱状图",
    "widget.heatmap-bars.desc": "逐日 Token 用量柱状图，窗口可在 7 天 / 30 天之间配置；2×4 宽版把合计与峰值移到标题行右端并带 MAX/TOTAL 标头",
    "widget.heatmap-bars.simToggle": "切换 7 天 / 30 天预览",
    "card.heatmap-bars.title": "Token 用量",
    "card.heatmap-bars.max": "MAX",
    "card.heatmap-bars.total": "TOTAL",
    "card.heatmap-bars.hint": "每根柱 = 2 天（悬停柱看该柱合计；标签是该柱的结束日）",
    "config.bars.range": "窗口",
    "config.bars.range.7": "近 7 天",
    "config.bars.range.30": "近 30 天",
    "config.bars.range.hint": "近 7 天 = 每天一根柱；近 30 天 = 每两天一根柱（30 根日柱在卡片宽度里只有 6px 宽，读不出量级）",
    "config.bars.monthMode.hint": "只对「近 7 天」生效：近 30 天窗口永远是滚动的",
    "config.monthMode.rolling7": "滚动(最近7天)",
    "config.monthMode.weekly": "每周对齐",
    "widget.quota-manage.name": "额度预测",
    "widget.quota-manage.desc": "按账期趋势预测月末用量百分比，并给出今日 token 用量与今日推荐用量",
    "widget.quota-manage.periodEnd": "账期 {m}-{d}",
    "widget.quota-manage.used": "今日用量",
    "widget.quota-manage.recommend": "今日推荐",
    "widget.quota-manage.simToggle": "超额状态",
    "widget.usage-bars.name": "用量柱状图",
    "widget.usage-bars.desc": "OpenCode 滚动/周/月三窗口用量柱状图",
    "widget.usage-rings.name": "用量环形图",
    "widget.usage-rings.desc": "OpenCode 滚动/周/月三窗口用量环形图",
    "widget.usage-rolling.name": "滚动用量",
    "widget.usage-rolling.desc": "OpenCode Go 滚动窗口用量配额",
    "widget.usage-weekly.name": "每周用量",
    "widget.usage-weekly.desc": "OpenCode Go 每周用量配额",
    "widget.usage-monthly.name": "每月用量",
    "widget.usage-monthly.desc": "OpenCode Go 每月用量配额",
    "widget.cc-whoami.name": "账户身份",
    "widget.cc-whoami.desc": "当前 Command Code 账户身份（用户名 / 邮箱 / 组织）",
    "widget.peak-pricing.name": "峰谷定价",
    "widget.peak-pricing.desc": "DeepSeek V4 峰谷定价：当前是否处于高峰时段（北京时间工作日 09:00–12:00 与 14:00–18:00 为高峰；周末与中国法定节假日全天低谷）",
    "card.peak.title": "峰谷定价",
    "card.peak.am": "上午 {range}",
    "card.peak.pm": "下午 {range}",
    "card.peak.offDay": "{reason} · 全天低谷",
    "card.peak.weekend": "周末",
    "card.peak.holiday.newyear": "元旦",
    "card.peak.holiday.spring": "春节",
    "card.peak.holiday.qingming": "清明节",
    "card.peak.holiday.labour": "劳动节",
    "card.peak.holiday.dragon": "端午节",
    "card.peak.holiday.midautumn": "中秋节",
    "card.peak.holiday.national": "国庆节",
    "card.peak.holiday.custom": "自定义低谷日",
    "card.peak.staleHint": "节假日表未覆盖 {year} 年（依据 {source}），目前只按工作日与周末判断 —— 可在「额外低谷日」里补上该年的放假日期",
    "sim.peak": "高峰/低峰",
    "config.peak.windows": "高峰时段（北京时间，逗号分隔，最多两段）",
    "config.peak.weekend": "周末全天低谷",
    "config.peak.holiday": "中国法定节假日全天低谷",
    "config.peak.timeZone": "时区",
    "config.peak.tz.beijing": "北京 (UTC+8)",
    "config.peak.tz.local": "本机时区",
    "config.peak.extra": "额外低谷日（2027-01-01 或 2027-02-05..2027-02-11）",
    "widget.sys-cpu.name": "CPU 状态",
    "widget.sys-cpu.desc": "本机 CPU 利用率与内存占用",
    "widget.cc-usage.name": "账期用量",
    "widget.cc-usage.desc": "账期内的请求数、成功率、Token 与消费摘要",
    "widget.sys-gpu.name": "GPU 状态",
    "widget.sys-gpu.desc": "本机 NVIDIA GPU 显存、利用率与温度",
    "widget.cc-credits.name": "用量柱状图",
    "widget.cc-credits.desc": "Credits 余额与 5h / 周额度窗口用量",
    "widget.sys-rings.name": "CPU·GPU 环形图",
    "widget.sys-rings.desc": "CPU / GPU 利用率双环形图",
    "widget.cc-windows.name": "用量环形图",
    "widget.cc-windows.desc": "5h / 周 / 月 三窗口用量环图",
    "widget.sys-board.name": "系统看板",
    "widget.sys-board.desc": "CPU/内存/GPU 显存与利用率全指标环形看板",
    "widget.cc-subscription.name": "套餐档位",
    "widget.cc-subscription.desc": "当前套餐等级（GOAT / Pro / Max …）与账期结束时间",
    "widget.cc-subscription.simToggle": "切换套餐等级预览",
    "widget.sys-gpu-line.name": "GPU 性能",
    "widget.sys-gpu-line.desc": "GPU 性能折线（最近约 20 分钟）",
    "widget.cc-window-5h.name": "5 小时窗口",
    "widget.cc-window-5h.desc": "5 小时额度窗口用量百分比与重置时间",
    "widget.cc-window-weekly.name": "周窗口",
    "widget.cc-window-weekly.desc": "周额度窗口用量百分比与重置时间",
    "widget.cc-window-monthly.name": "月窗口",
    "widget.cc-window-monthly.desc": "账期月额度用量百分比（已用 / 已用+剩余）与账期结束时间",
    "widget.deepseek-balance.name": "DeepSeek 余额",
    "widget.deepseek-balance.desc": "DeepSeek 官方开放平台余额：充值 / 赠送余额、按本机观测的今日消耗，以及本次对话的花费（≈ 为按当前费率估算）",
    "widget.deepseek-balance.simToggle": "余额充足 / 偏低 / 不足 / 未配置",
    "deepseek.title": "DeepSeek 余额",
    "deepseek.justNow": "刚刚更新",
    "deepseek.updated": "{ago} 前更新",
    "deepseek.granted": "赠送",
    "deepseek.toppedUp": "充值",
    "deepseek.spentToday": "今日消耗",
    "deepseek.sessionSpend": "对话消耗",
    "deepseek.tokens": "tok",
    "deepseek.insufficient": "余额不足",
    "deepseek.insufficientHint": "账户余额不足，DeepSeek 已暂停该账号的 API 调用；充值后自动恢复",
    "deepseek.lowHint": "余额低于你设的预警阈值 {low}",
    "deepseek.spentHint": "今日消耗＝host 采样余额得到的当日下降量之和（官方只提供余额、没有用量接口）：dsh 未运行期间的消耗不计入，充值 / 赠送不计为负消耗",
    "deepseek.estHint": "对话消耗按当前费率估算整段会话：会话记录里没有逐请求时间戳，无法把高峰 / 低谷分开计价（≈）",
    "deepseek.unconfigured": "未配置 DEEPSEEK_API_KEY — host 自动读取环境变量 / $DSH_HOME/.credentials.yaml / .env，重启后自动生效",
    "deepseek.unauthorized": "DEEPSEEK_API_KEY 被拒绝（401）— 检查密钥是否仍然有效",
    "deepseek.unloaded": "dsh web 未重启，等待 host 路由加载（重启后自动刷新）",
    "deepseek.timeout": "DeepSeek 余额接口超时，稍后自动重试",
    "deepseek.unavailable": "DeepSeek 余额接口暂不可用",
    "deepseek.short.unconfigured": "未配置密钥",
    "deepseek.short.unauthorized": "密钥被拒绝",
    "deepseek.short.unloaded": "host 未加载",
    "deepseek.short.timeout": "读取超时",
    "deepseek.short.unavailable": "暂不可用",
    "deepseek.short.failed": "读取失败",
    "deepseek.waiting": "等待余额数据…",
    "deepseek.failed": "余额读取失败（{code}）",
    "card.deepseek-balance.low": "余额预警阈值",
    "card.deepseek-balance.lowHint": "余额低于该值时大数字转为警示色（低于一半为红色）；默认 10，单位与账户币种一致",
    "widget.github-contrib.name": "提交热度图",
    "widget.github-contrib.desc": "GitHub 提交热度图（同款 5 级绿）。2×2 近 3 个月，2×4 近一年（与 GitHub 个人页同款窗口）；默认读本机已登录的账号，也可填用户名",
    "widget.github-stars.name": "Stars",
    "widget.github-stars.desc": "仓库 Stars（副标题是仓库名，副行是 Forks）；同时监控多个仓库时单击卡片切换",
    "widget.github-issues.name": "未关闭 Issue",
    "widget.github-issues.desc": "未关闭 Issue 数（不含 PR），副行是其中没有任何人回复的数量——配了 token 才测得到，否则显示「回复（配置 token 后可测）」",
    "widget.github-push.name": "最近提交",
    "widget.github-push.desc": "距离最近一次 push 多久（12s / 5m / 3h / 6d），副行是最新 Release tag",
    "widget.github-board.name": "仓库脉搏",
    "widget.github-board.desc": "2×4 汇总板：Stars / 未关闭 Issue / 未回复 / 最近提交 并排，标题行给出仓库全名与最新 Release",
    "widget.usage-mix.name": "套餐总览",
    "widget.usage-mix.desc": "跨平台额度看板：今日用量打头，右上角环形显示全场最紧的占用，下面每个平台（含号池，第二个用罗马数字 Ⅱ）各占一行",
    "card.usage-mix.opencode": "OpenCode Go",
    "card.usage-mix.commandcode": "Command Code",
    "card.usage-mix.today": "今日",
    "card.usage-mix.legend": "{win} · {at}",
    "card.usage-mix.mark.Δ": "滚动",
    "card.usage-mix.mark.W": "周",
    "card.usage-mix.mark.M": "月",
    "card.usage-mix.mark.5h": "5h ",
    "card.usage-mix.cfg.daily": "显示今日用量",
    "card.usage-mix.cfg.opencode": "显示 OpenCode Go（退订后关掉）",
    "card.usage-mix.cfg.commandcode": "显示 Command Code",
    "widget.trajectory-stats.name": "轨迹占比",
    "widget.trajectory-stats.desc": "「对话轨迹」的统计版：输入 / 模型 / 工具 各自的时长与占比，点按可切换大数字看模型或工具",
    "widget.trajectory-stats.simToggle": "切换大数字：模型 / 工具",
    "card.trajectory-stats.cycleHint": "单击切换大数字：模型 → 工具",
    "card.trajectory-stats.input": "输入",
    "card.trajectory-stats.model": "模型",
    "card.trajectory-stats.tool": "工具",
    "widget.peak-pricing-board.name": "峰谷时段表",
    "widget.peak-pricing-board.desc": "2×4 宽版峰谷定价：今天接下来的计费时刻表——高峰 09:00–12:00 / 14:00–18:00、其余低谷，正在计费的那一行高亮，并给出距离下一段切换还有多久；周末与中国法定节假日写明「全天低谷」的原因（与 2×2 峰谷定价同一套规则；可自定时段 / 时区 / 额外低谷日）",
    "card.peak-pricing-board.title": "峰谷时段表",
    "card.peak-pricing-board.peak": "高峰",
    "card.peak-pricing-board.off": "低谷",
    "card.peak-pricing-board.until": "本段至",
    "card.peak-pricing-board.next": "下一段",
    "card.peak-pricing-board.nextDay": "下一段（次日）",
    "card.peak-pricing-board.nextDayShort": "次日",
    "card.peak-pricing-board.nextOff": "恢复高峰",
    "card.peak-pricing-board.left": "还有 {d}",
    "card.peak-pricing-board.dow.0": "周日",
    "card.peak-pricing-board.dow.1": "周一",
    "card.peak-pricing-board.dow.2": "周二",
    "card.peak-pricing-board.dow.3": "周三",
    "card.peak-pricing-board.dow.4": "周四",
    "card.peak-pricing-board.dow.5": "周五",
    "card.peak-pricing-board.dow.6": "周六",
    "card.peak-pricing-board.simToggle": "高峰 / 低谷 / 节假日 / 周末",
    "card.peak-pricing-board.staleHint": "节假日表未覆盖 {year} 年（依据 {source}），只按工作日与周末判断 —— 可在「额外低谷日」里补上该年的放假日期",
    "card.peak-pricing-board.weekend": "周末",
    "card.peak-pricing-board.holiday.newyear": "元旦",
    "card.peak-pricing-board.holiday.spring": "春节",
    "card.peak-pricing-board.holiday.qingming": "清明节",
    "card.peak-pricing-board.holiday.labour": "劳动节",
    "card.peak-pricing-board.holiday.dragon": "端午节",
    "card.peak-pricing-board.holiday.midautumn": "中秋节",
    "card.peak-pricing-board.holiday.national": "国庆节",
    "card.peak-pricing-board.holiday.custom": "自定义低谷日",
    "config.peak-pricing-board.windows": "本卡时段（留空则跟随下面的高峰时段；逗号分隔，最多两段）",
    "config.peak-pricing-board.peakWindows": "高峰时段（北京时间，逗号分隔，最多两段）",
    "config.peak-pricing-board.weekendOff": "周末全天低谷",
    "config.peak-pricing-board.holidayOff": "中国法定节假日全天低谷",
    "config.peak-pricing-board.timeZone": "时区",
    "config.peak-pricing-board.tz.beijing": "北京 (UTC+8)",
    "config.peak-pricing-board.tz.local": "本机时区",
    "config.peak-pricing-board.extraHolidays": "额外低谷日（2027-01-01 或 2027-02-05..2027-02-11）",
    "widget.goal-progress.name": "目标进度",
    "widget.goal-progress.desc": "目标的生命周期阶段（进行中 / 已暂停 / 受阻 / 已完成 / 无目标），下面三行是目标原文、轮次 / 上限（还没跑过轮次时印「尚未开始」，绝不印 0 / 256）、最近变更；没有目标时保持安静空态，不会从组件栏消失",
    "widget.goal-progress.simToggle": "切换 无目标 / 进行中 / 刚创建 / 受阻 / 已完成 预览",
    "card.goal-progress.title": "目标进度",
    "card.goal-progress.phase.active": "进行中",
    "card.goal-progress.phase.paused": "已暂停",
    "card.goal-progress.phase.blocked": "受阻",
    "card.goal-progress.phase.complete": "已完成",
    "card.goal-progress.phase.none": "无目标",
    "card.goal-progress.noGoal": "当前会话没有目标",
    "card.goal-progress.objective": "目标",
    "card.goal-progress.roundsLabel": "轮次/上限",
    "card.goal-progress.rounds": "{done} / {max}",
    "card.goal-progress.roundsNotStarted": "尚未开始",
    "card.goal-progress.changed": "最近变更",
    "card.goal-progress.ago": "{ago} 前",
    "card.goal-progress.blockedLegend": "原因：{reason}",
    "widget.subagent.name": "子代理",
    "widget.subagent.desc": "本会话派出的子代理是什么：几个、几个可持续、分别是谁",
    "card.subagent.title": "子代理",
    "card.subagent.legendActive": "最久活跃 {dur}",
    "card.subagent.legendEarliest": "最早 {ago} 前创建",
    "card.subagent.continuable": "持续型",
    "card.subagent.recent": "最近",
    "card.subagent.ago": "{ago} 前",
    "widget.subagent.simToggle": "切换 最久活跃 / 最早创建 预览",
    "card.subagent.none": "暂无子代理",
    "widget.guard.name": "权限档位",
    "widget.guard.desc": "本会话生效的权限档位：官方权限选择器的那枚盾牌 + 档位名（投影已把 preset / 沙箱 / 审批三个旋钮折成一个值）",
    "widget.guard.simToggle": "切换档位",
    "card.guard.title": "权限档位",
    "card.guard.preset.readOnly": "仅可查看",
    "card.guard.preset.workspaceWrite": "工作区内修改",
    "card.guard.preset.fullAccess": "完全权限",
    "widget.jobs.name": "后台任务",
    "widget.jobs.desc": "本会话的后台任务：几个在跑、最久跑了多久、最近一个是什么",
    "card.jobs.title": "后台任务",
    "card.jobs.legend": "最久 {longest} · 共 {total} 个",
    "card.jobs.idle": "已结束 {n} 个",
    "card.jobs.longest": "最久",
    "card.jobs.newest": "最近",
    "card.jobs.failed": "失败",
    "widget.jobs.simToggle": "切换 运行中 / 已跑完 / 空列表 预览",
    "widget.sys-disk.name": "磁盘与自检",
    "widget.sys-disk.desc": "各盘剩余空间（条=已用、文字=剩余）、DSH 会话日志的体积与最近一小时增速、web 进程自身的占用——长跑 harness 最真实的运维风险",
    "widget.sys-disk.simToggle": "切换 会话目录可读 / 读不到",
    "card.sys-disk.title": "磁盘与自检",
    "card.sys-disk.row": "{mount} 剩余 {free} / {total}",
    "card.sys-disk.rowShort": "{mount} 剩 {free}",
    "card.sys-disk.logLine": "DSH 会话日志 {size} · 近 1 小时 +{recent} 个文件",
    "card.sys-disk.procLine": "dsh web 进程内存 {rss} · CPU {cpu} · 已运行 {uptime}",
    "card.sys-disk.hidden": "另有 {n} 块盘空间更充裕：{list}",
    "card.sys-disk.hintLog": "会话日志共 {files} 个文件",
    "card.sys-disk.hint": "dsh web 进程 PID {pid} · {rss} RSS · {cpu} CPU · 已跑 {uptime}",
    "widget.window-forecast.name": "限流预测",
    "widget.window-forecast.desc": "按当前速率，5 小时 / 周额度窗口会不会在重置前触及限额（额度预测只管月窗口）",
    "widget.window-forecast.simToggle": "稍后读表",
    "card.window-forecast.title": "限流预测",
    "card.window-forecast.win5h": "5h",
    "card.window-forecast.winWeekly": "周",
    "card.window-forecast.projected": "预计",
    "card.window-forecast.fillIn": "{d} 后触及限额",
    "card.window-forecast.noFill": "不会触及限额 · {d}",
    "card.window-forecast.resetLeft": "额度重置",
    "widget.sys-net.name": "网络吞吐",
    "widget.sys-net.desc": "本机网卡的实时收发速率（两次计数采样差分），以及当前最忙的那张网卡",
    "card.sys-net.title": "网络吞吐",
    "card.sys-net.busiest": "最忙",
    "card.sys-net.simToggle": "在线 / 零流量 / 等待样本",
    "card.sys-net.adapters": "{n} 张网卡",
    "widget.sys-power.name": "供电",
    "widget.sys-power.desc": "是否在用电池、剩余电量与预计续航，以及当前 Windows 电源方案",
    "card.sys-power.title": "供电",
    "card.sys-power.source.ac": "插电",
    "card.sys-power.source.battery": "电池",
    "card.sys-power.source.unknown": "供电未知",
    "card.sys-power.desktop": "台式机（无电池）",
    "card.sys-power.chargeUnknown": "电量未知",
    "card.sys-power.row.left": "剩余",
    "card.sys-power.row.scheme": "电源方案",
    "card.sys-power.hintUnknown": "系统没有报告剩余续航估算值，因此本卡不显示「剩余」这一行",
    "card.sys-power.simToggle": "切换供电状态",
    "widget.sys-procs.name": "进程内存占用",
    "widget.sys-procs.desc": "按工作集内存（Working Set / RSS）排序的前几名进程，以及占用最高的那个进程的工作集字节数；多 agent / 多模型并行时回答「哪个进程占着最多内存」",
    "widget.sys-procs.simToggle": "切换 多进程 / 单进程 预览",
    "card.sys-procs.title": "进程内存占用",
    "widget.sys-services.name": "本地依赖",
    "widget.sys-services.desc": "本机关键端口（DSH web；本地模型运行时按需开启）的存活与延迟，以及代理出口能否真的出网——端口在听不等于能出网。不跑本地模型时那两行根本不出现，所以不会有「未运行」的假警报",
    "card.sys-services.title": "本地依赖",
    "card.sys-services.up": "通",
    "card.sys-services.down": "未运行",
    "card.sys-services.verdictOk": "出口正常",
    "card.sys-services.verdictFail": "出口不通",
    "card.sys-services.verdictWait": "检测中",
    "card.sys-services.egressOk": "出口 {ms}",
    "card.sys-services.egressPort": "代理 {ms}",
    "card.sys-services.egressDetail": "出口探针失败：{error}",
    "card.sys-services.noRule": "TCP 在听不等于能出网",
    "card.sys-services.cfg.ollama": "显示 Ollama（本地大模型）",
    "card.sys-services.cfg.lmstudio": "显示 LM Studio",
    "card.sys-services.cfg.hint": "不跑本地模型就别开：关掉的端口不显示那一行，也就不会有「未运行」的假警报",
    "card.sys-services.simToggle": "切换预览状态",
    "widget.session-cost.name": "本会话成本",
    "widget.session-cost.desc": "把本会话的四桶 token 按价格表折成钱，并标出这个金额的来源（官方价 / 中转价 / 免费路由 / 估算价）",
    "widget.session-cost.simToggle": "命中价 / 高峰价 / 无价格表",
    "card.session-cost.title": "本会话成本",
    "card.session-cost.uncached": "未命中",
    "card.session-cost.read": "缓存命中",
    "card.session-cost.output": "输出",
    "card.session-cost.src.official": "官方价",
    "card.session-cost.src.reseller": "中转价",
    "card.session-cost.src.local": "免费路由",
    "card.session-cost.src.fallback": "估算价",
    "card.session-cost.src.unknown": "来源未标注",
    "card.session-cost.noTable": "无价格表 · 仅 token",
    "card.session-cost.noRoute": "无模型路由 · 仅 token",
    "card.session-cost.noRule": "无匹配价 · 仅 token",
    "card.session-cost.estHint": "按当前费率估算整段：会话记录里没有逐请求时间戳，无法把高峰 / 低谷时段分开计价，所以金额是估算值（≈）",
    "widget.github-notify.name": "待我处理",
    "widget.github-notify.desc": "GitHub 上等我的未读线程：review 请求 / @提及 / 指派，以及最新的一条；需要 token 或 gh 登录（未登录时该卡不出现）",
    "card.github-notify.title": "待我处理",
    "card.github-notify.review": "Review 请求",
    "card.github-notify.mention": "提及",
    "card.github-notify.assign": "指派",
    "card.github-notify.quiet": "暂无待处理",
    "card.github-notify.noNewest": "最新一条未提供",
    "card.github-notify.outside": "另有 {n} 条 CI / 其它未列入上面三行",
    "card.github-notify.reason.review_requested": "Review 请求",
    "card.github-notify.reason.mention": "提及",
    "card.github-notify.reason.assign": "指派",
    "card.github-notify.reason.ci_activity": "CI 活动",
    "card.github-notify.reason.other": "其它",
    "card.github-notify.reason.comment": "评论",
    "card.github-notify.reason.author": "你发起的",
    "card.github-notify.reason.state_change": "状态变化",
    "card.github-notify.reason.subscribed": "已订阅",
    "card.github-notify.reason.team_mention": "团队提及",
    "card.github-notify.reason.invitation": "邀请",
    "card.github-notify.reason.security_alert": "安全告警",
    "card.github-notify.reason.manual": "手动订阅",
    "sim.notify": "未读 / 清空 / 仅 CI / 缺读数 / 未登录",
  },
  en: {
    "usage.title": "OpenCode Usage",
    "usage.totalKey": "All Keys",
    "usage.cycleHint": "Click to cycle: {chain}",
    "usage.resets": "Resets {date}",
    "usage.rolling": "Rolling",
    "usage.week": "Week",
    "usage.month": "Month",
    "group.commandcode": "Command Code",
    "group.deepseek": "DeepSeek Official",
    "cc.notConfigured": "COMMANDCODE_API_KEY not configured (host auto-reads env / credentials, no manual entry)",
    "cc.unconfigured": "COMMANDCODE_API_KEY not configured — the host auto-reads env / $DSH_HOME/.credentials.yaml / .env; effective after a restart",
    "cc.unloaded": "dsh web not restarted — waiting for the host route (auto-refresh after restart)",
    "cc.unavailable": "Command Code service unavailable",
    "cc.account": "Account identity",
    "cc.tokens": "tokens",
    "cc.requests": "requests",
    "cc.successRate": "success",
    "cc.spend": "Spend",
    "cc.credits": "credits",
    "cc.free": "Free",
    "cc.purchased": "Purchased",
    "cc.fiveHour": "5h",
    "cc.weekly": "Week",
    "cc.periodEnd": "Period ends",
    "cc.period": "Ends {m}-{d}",
    "cc.title": "Command Code",
    "cc.roleUsage": "Billing usage",
    "cc.roleCredits": "Credits",
    "cc.roleWindow": "Usage rings",
    "cc.roleAccount": "Account",
    "cc.win5h": "5h Window",
    "cc.winWeekly": "Weekly window",
    "cc.winMonthly": "Monthly window",
    "cc.limit5h": "5-hour limit",
    "cc.limitWeek": "Weekly limit",
    "cc.limitMonth": "Monthly limit",
    "cc.resets": "Resets",
    "cc.cancelAtEnd": "Cancels at period end",
    "cc.cycleHint": "Click to switch account: {chain}",
    "sysinfo.cpu": "CPU",
    "sysinfo.gpu": "GPU",
    "sysinfo.mem": "Memory",
    "sysinfo.vram": "VRAM",
    "sysinfo.memSub": "Mem {used} / {total}",
    "sysinfo.interval": "Refresh interval",
    "sysinfo.intervalCustom": "Custom",
    "sysinfo.intervalCustomValue": "Custom interval (s)",
    "sysinfo.noGpu": "No NVIDIA GPU detected",
    "sysinfo.waiting": "Waiting for device data…",
    "sysinfo.bigMetric": "Big figure",
    "sysinfo.bigVram": "VRAM (GB)",
    "sysinfo.bigTemp": "Temp (°C)",
    "sysinfo.bigUtil": "Utilization (%)",
    "sysinfo.bigMem": "Memory (GB)",
    "sysinfo.bigHint": "Click to cycle the big figure: {chain}",
    "sysinfo.points": "Sparkline samples",
    "group.github": "GitHub",
    "config.github.user": "GitHub user",
    "config.github.repos": "Repos to watch (owner/name, comma separated, max 4)",
    "config.github.hint": "Empty = use this machine's own GitHub login (credentials / gh CLI)",
    "github.staleHost": "host route not loaded — restart dsh web",
    "github.unavailable": "GitHub unavailable",
    "github.noUser": "Not signed in to GitHub — set a user or a token",
    "github.noRepo": "No repo — set owner/name or sign in to GitHub",
    "github.cycle": "Click to switch repo: {chain}",
    "github.stars": "Stars",
    "github.forks": "Forks",
    "github.issues": "Open Issues",
    "github.unanswered": "Replies",
    "github.unansweredUnknown": "Replies (needs a token)",
    "github.push": "Latest Push",
    "github.release": "Release {tag}",
    "github.noRelease": "No release yet",
    "github.contrib.total": "{n} contributions",
    "github.contrib.unit": "contributions",
    "github.contrib.title": "Contributions",
    "github.board.title": "Repo pulse",
    "github.contrib.windowYear": "last year",
    "github.contrib.windowQuarter": "last 3 months",
    "tz.local": "Local",
    "tz.beijing": "Beijing",
    "tz.tokyo": "Tokyo",
    "tz.london": "London",
    "tz.newyork": "New York",
    "tz.utc": "UTC",
    "widget.counts.name": "Turns · Steps",
    "widget.counts.desc": "Turns and steps of the current session",
    "card.counts.value": "{turns} turns · {steps} steps",
    "widget.llm.name": "LLM Time",
    "widget.llm.desc": "Cumulative model inference time",
    "widget.tool.name": "Tool Calls",
    "widget.tool.desc": "Three detail rows (default 失败 / 平均每次 / 工具耗时占比) under the cumulative-time figure; rows are swappable in Config",
    "card.tool.running": "Running",
    "card.tool.slowest": "Slowest",
    "card.tool.failed": "Failed",
    "card.tool.mean": "Average",
    "card.tool.share": "Tool share",
    "card.tool.calls": "{n} calls · {m} tools",
    "card.tool.hint": "Up to {max} rows · drag a row to reorder: the top one shows first on the card",
    "widget.ttft.name": "First-token Latency",
    "widget.ttft.desc": "Average first-token latency",
    "widget.tps.name": "Decode Rate",
    "widget.tps.desc": "Decode throughput speed",
    "widget.cache.name": "Cache Hit",
    "widget.cache.desc": "Cache hit rate as a ring, with this session's token breakdown",
    "card.cache.unit": "tok",
    "card.cache.uncached": "Uncached input",
    "card.cache.read": "Cache read",
    "card.cache.output": "Output",
    "widget.tokens.name": "Session Tokens",
    "widget.tokens.desc": "This session's token total with its input / output split (session scope, not the per-day cross-session usage)",
    "card.tokens.input": "Input",
    "card.tokens.output": "Output",
    "widget.context.name": "Context Compaction",
    "widget.context.desc": "Context usage percent with the top-right two-tap Compact button; below it folds / reclaimed tokens / items folded",
    "card.context.title": "Context Compaction",
    "card.context.waiting": "Waiting for context data",
    "card.context.compact": "Compact",
    "card.context.confirm": "Confirm",
    "card.context.folds": "Folds",
    "card.context.reclaimed": "Reclaimed",
    "card.context.items": "Items folded",
    "card.context.recent": "Last {ago} ago",
    "widget.context-water.name": "Context Level",
    "widget.context-water.desc": "System/tools/messages share as a segmented bar",
    "card.contextWater.title": "Context Used",
    "card.contextWater.system": "System prompt",
    "card.contextWater.tools": "Tools",
    "card.contextWater.messages": "Messages",
    "widget.task.name": "Tasks",
    "widget.task.desc": "The todo entries themselves: the figure is the in-progress count with the counts line beside it, then up to four rows (in-progress first, then pending); an empty list shows \"No tasks\"",
    "card.task.small": "active · {pending} pending",
    "card.task.doing": "In progress",
    "card.task.pending": "Pending",
    "card.task.done": "Done",
    "card.task.none": "No tasks",
    "widget.task.simToggle": "Toggle no-tasks / with-tasks preview",
    "widget.trajectory.name": "Trajectory",
    "widget.trajectory.desc": "The official Trajectory rail as a card: one colored bar per input / model / tool beat, rolling right as the model keeps calling tools",
    "card.trajectory.legend": "In {input}  Model {model}  Tool {tool}",
    "card.trajectory.input": "Input",
    "card.trajectory.model": "Model",
    "card.trajectory.tool": "Tool",
    "config.laneSizing": "Lane Width",
    "config.laneSizing.time": "By duration",
    "config.laneSizing.equal": "Equal width",
    "widget.harness-board.name": "Session Overview",
    "widget.harness-board.desc": "The session numbers the composer stats line was split into, on ONE 2×4: turns / LLM / tools / rate by default, up to ten, picked and row-dragged in the component config (five per row, wrapping to two rows; a 2×2 card prints its figure at 20px, a board figure is 13px — the board scans a row, the card shows one number)",
    "metric.turns": "Turns",
    "metric.steps": "Steps",
    "metric.llm": "LLM",
    "metric.tool": "Tools",
    "metric.ttft": "TTFT",
    "metric.tps": "Rate",
    "metric.cache": "Cache",
    "metric.in": "In",
    "metric.out": "Out",
    "metric.context": "Context",
    "metric.todoDoing": "Active",
    "metric.todoPending": "Todo",
    "metric.toolFail": "Failed",
    "metric.folds": "Folds",
    "metric.reclaimed": "Reclaimed",
    "metric.running": "Running",
    "widget.quote.name": "Daily Quote",
    "widget.quote.desc": "Shows a custom sentence you typed (hidden while empty)",
    "card.quote.title": "Daily Quote",
    "config.quoteText": "Quote Text",
    "config.showTitle": "Show Title",
    "config.align": "Horizontal Align",
    "config.valign": "Vertical Position",
    "config.wrap": "Allow Wrap",
    "quote.previewPlaceholder": "(shown after you type a quote)",
    "group.clock": "Clock",
    "widget.clock.name": "Clock",
    "widget.clock.desc": "An analog or digital clock with a selectable zone (Local / Beijing / Tokyo / London / New York / UTC) and a ticking second hand",
    "card.clock.face": "Dial",
    "card.clock.faceAnalog": "Analog",
    "card.clock.faceDigital": "Digital",
    "card.clock.timeZone": "Time zone",
    "card.clock.showLabel": "Show the zone caption",
    "card.clock.seconds": "Show seconds",
    "card.clock.h24": "24-hour clock",
    "card.clock.am": "AM",
    "card.clock.pm": "PM",
    "card.clock.md": "{m}/{d}",
    "card.clock.weekday.0": "Sun",
    "card.clock.weekday.1": "Mon",
    "card.clock.weekday.2": "Tue",
    "card.clock.weekday.3": "Wed",
    "card.clock.weekday.4": "Thu",
    "card.clock.weekday.5": "Fri",
    "card.clock.weekday.6": "Sat",
    "group.calendar": "Calendar",
    "widget.calendar.name": "Calendar",
    "widget.calendar.desc": "This month at a glance: today badged, weekends or statutory holidays tinted, Monday- or Sunday-first (the zone decides which day is today); days with a DSH scheduled task get a dot and the 2×4 lists the upcoming ones (a deployment without the schedule subsystem falls back to a plain month grid)",
    "card.calendar.timeZone": "Time zone",
    "card.calendar.weekStart": "Week starts",
    "card.calendar.weekStartMonday": "Monday",
    "card.calendar.weekStartSunday": "Sunday",
    "card.calendar.tint": "Highlight",
    "card.calendar.tintWeekend": "Weekends",
    "card.calendar.tintHoliday": "Public holidays",
    "card.calendar.tintNone": "None",
    "card.calendar.showOther": "Show adjacent months",
    "card.calendar.agenda": "Upcoming",
    "card.calendar.agendaEmpty": "No upcoming tasks",
    "card.calendar.nextHint": "Next {title} · in {left}",
    "card.calendar.whenToday": "Today {time}",
    "card.calendar.whenDate": "{m}/{d} {time}",
    "card.calendar.monthLabel": "{month} {y}",
    "card.calendar.month.1": "January",
    "card.calendar.month.2": "February",
    "card.calendar.month.3": "March",
    "card.calendar.month.4": "April",
    "card.calendar.month.5": "May",
    "card.calendar.month.6": "June",
    "card.calendar.month.7": "July",
    "card.calendar.month.8": "August",
    "card.calendar.month.9": "September",
    "card.calendar.month.10": "October",
    "card.calendar.month.11": "November",
    "card.calendar.month.12": "December",
    "card.calendar.weekday.0": "S",
    "card.calendar.weekday.1": "M",
    "card.calendar.weekday.2": "T",
    "card.calendar.weekday.3": "W",
    "card.calendar.weekday.4": "T",
    "card.calendar.weekday.5": "F",
    "card.calendar.weekday.6": "S",
    "card.calendar.holidayStale": "The statutory holiday table does not cover {y} yet — weekends only this month",
    "group.time": "Time",
    "widget.task-timer.name": "Task Timer",
    "widget.task-timer.desc": "How long this turn has run, and what it is waiting on right now (a tool call or a model step); both come from projections the session already has, advancing every second while a turn runs",
    "card.task-timer.title": "Task Timer",
    "card.task-timer.idle": "Idle",
    "card.task-timer.running": "Running",
    "card.task-timer.labelTurn": "This turn",
    "card.task-timer.labelTool": "Running tool",
    "card.task-timer.labelModel": "Model",
    "card.task-timer.labelTools": "Tools",
    "card.task-timer.labelCalls": "Session turns",
    "card.task-timer.labelSteps": "Session steps",
    "card.task-timer.toolCount": "{n} in parallel",
    "card.task-timer.simToggle": "Cycle preview state",
    "widget.stopwatch.name": "Stopwatch",
    "widget.stopwatch.desc": "An interactive stopwatch: start / pause / resume / reset, counted up by the card itself every second, with the state kept in the instance config so it survives a refresh and another browser",
    "widget.stopwatch.simToggle": "Cycle not-started / running / paused",
    "card.stopwatch.title": "Stopwatch",
    "card.stopwatch.ready": "Not started",
    "card.stopwatch.running": "Running",
    "card.stopwatch.paused": "Paused · {t}",
    "card.stopwatch.start": "Start",
    "card.stopwatch.resume": "Resume",
    "card.stopwatch.pause": "Pause",
    "card.stopwatch.reset": "Reset",
    "widget.countdown.name": "Countdown",
    "widget.countdown.desc": "Tap a duration capsule (1 / 3 / 5 / 10 minutes, plus one custom slot in the config) to start; the running view matches the stopwatch, with a back chevron in the title row. It can also count down to the next DSH scheduled task",
    "widget.countdown.simToggle": "Cycle capsules / custom / paused / running / time-up / scheduled preview",
    "card.countdown.title": "Countdown",
    "card.countdown.back": "Back",
    "card.countdown.mode": "Target",
    "card.countdown.mode.pick": "Duration capsules",
    "card.countdown.mode.next": "Next scheduled task",
    "card.countdown.unitMin": "min",
    "card.countdown.custom": "Custom minutes",
    "card.countdown.customHint": "An integer 1–1440: it takes the longest slot (the 10-minute one). Leave it empty for the fixed 1 / 3 / 5 / 10 grid",
    "card.countdown.done": "Time is up",
    "card.countdown.noSchedule": "No upcoming task",
    "card.countdown.unavailable": "Scheduled tasks unavailable",
    "card.countdown.start": "Start",
    "card.countdown.resume": "Resume",
    "card.countdown.pause": "Pause",
    "card.countdown.reset": "Reset",
    "card.countdown.rule.every": "every {d}",
    "card.countdown.rule.daily": "daily {time}",
    "card.countdown.rule.weekly": "weekly {d}",
    "card.countdown.rule.cron": "{expr}",
    "card.countdown.rule.once": "one-shot",
    "card.countdown.dow.1": "Mon",
    "card.countdown.dow.2": "Tue",
    "card.countdown.dow.3": "Wed",
    "card.countdown.dow.4": "Thu",
    "card.countdown.dow.5": "Fri",
    "card.countdown.dow.6": "Sat",
    "card.countdown.dow.7": "Sun",
    "widget.heatmap.name": "Token Heatmap",
    "widget.heatmap.desc": "Daily token usage heatmap (self-accounted). 2×2 shows a ~3-month calendar, 2×4 the ~half-year history; switch size in the market",
    "card.heatmap.title": "Token Usage",
    "config.monthMode": "Window Alignment",
    "config.monthMode.rolling": "Rolling (today right)",
    "config.monthMode.quarter": "Quarter-aligned",
    "config.timeZone": "Accounting Timezone",
    "config.timeZone.beijing": "Beijing (UTC+8)",
    "config.timeZone.local": "Follow system",
    "widget.heatmap-bars.name": "Token Bars",
    "widget.heatmap-bars.desc": "Daily token-usage bars with a 7-day / 30-day window setting; the 2×4 moves the figures into the title row with MAX/TOTAL labels",
    "widget.heatmap-bars.simToggle": "7-day / 30-day preview",
    "card.heatmap-bars.title": "Token Usage",
    "card.heatmap-bars.max": "MAX",
    "card.heatmap-bars.total": "TOTAL",
    "card.heatmap-bars.hint": "each bar = 2 days (hover a bar for its total; the label is the day the bar ends on)",
    "config.bars.range": "Window",
    "config.bars.range.7": "Last 7 days",
    "config.bars.range.30": "Last 30 days",
    "config.bars.range.hint": "7 days = one bar per day; 30 days = one bar per two days (thirty daily bars are 6px wide in a card and show no magnitude)",
    "config.bars.monthMode.hint": "Only applies to the 7-day window: the 30-day window always rolls",
    "config.monthMode.rolling7": "Rolling (last 7 days)",
    "config.monthMode.weekly": "Weekly aligned",
    "widget.quota-manage.name": "Quota Forecast",
    "widget.quota-manage.desc": "Projects the month-end usage percent from the billing period's pace, with today's tokens vs the recommended budget",
    "widget.quota-manage.periodEnd": "Ends {m}-{d}",
    "widget.quota-manage.used": "Today",
    "widget.quota-manage.recommend": "Budget",
    "widget.quota-manage.simToggle": "Over budget",
    "widget.usage-bars.name": "Usage Bars",
    "widget.usage-bars.desc": "OpenCode rolling/weekly/monthly usage bars",
    "widget.usage-rings.name": "Usage Rings",
    "widget.usage-rings.desc": "OpenCode rolling/weekly/monthly usage rings",
    "widget.usage-rolling.name": "Rolling Usage",
    "widget.usage-rolling.desc": "OpenCode Go rolling-window usage quota",
    "widget.usage-weekly.name": "Weekly Usage",
    "widget.usage-weekly.desc": "OpenCode Go weekly usage quota",
    "widget.usage-monthly.name": "Monthly Usage",
    "widget.usage-monthly.desc": "OpenCode Go monthly usage quota",
    "widget.cc-whoami.name": "Account Identity",
    "widget.cc-whoami.desc": "Current Command Code account identity (name / email / org)",
    "widget.peak-pricing.name": "Peak Pricing",
    "widget.peak-pricing.desc": "DeepSeek V4 peak pricing: whether now is a peak window (Beijing time, weekdays 09:00–12:00 & 14:00–18:00; weekends and Chinese public holidays are off-peak all day)",
    "card.peak.title": "Peak Pricing",
    "card.peak.am": "Morning {range}",
    "card.peak.pm": "Afternoon {range}",
    "card.peak.offDay": "{reason} · off-peak all day",
    "card.peak.weekend": "Weekend",
    "card.peak.holiday.newyear": "New Year's Day",
    "card.peak.holiday.spring": "Spring Festival",
    "card.peak.holiday.qingming": "Qingming",
    "card.peak.holiday.labour": "Labour Day",
    "card.peak.holiday.dragon": "Dragon Boat Festival",
    "card.peak.holiday.midautumn": "Mid-Autumn Festival",
    "card.peak.holiday.national": "National Day",
    "card.peak.holiday.custom": "Custom off-peak day",
    "card.peak.staleHint": "The holiday table does not cover {year} (source: {source}) — weekday/weekend only. Add that year's dates under \"Extra off-peak days\".",
    "sim.peak": "Peak/Off-Peak",
    "config.peak.windows": "Peak windows (Beijing time, comma separated, max 2)",
    "config.peak.weekend": "Weekends off-peak all day",
    "config.peak.holiday": "Chinese public holidays off-peak all day",
    "config.peak.timeZone": "Time zone",
    "config.peak.tz.beijing": "Beijing (UTC+8)",
    "config.peak.tz.local": "Local time",
    "config.peak.extra": "Extra off-peak days (2027-01-01 or 2027-02-05..2027-02-11)",
    "widget.sys-cpu.name": "CPU Status",
    "widget.sys-cpu.desc": "Local CPU utilization and memory usage",
    "widget.cc-usage.name": "Billing Usage",
    "widget.cc-usage.desc": "Requests, success rate, tokens and spend for the billing period",
    "widget.sys-gpu.name": "GPU Status",
    "widget.sys-gpu.desc": "Local NVIDIA GPU VRAM, utilization and temperature",
    "widget.cc-credits.name": "Usage Bars",
    "widget.cc-credits.desc": "Credit balance with 5h / weekly window usage",
    "widget.sys-rings.name": "CPU · GPU Rings",
    "widget.sys-rings.desc": "CPU / GPU utilization twin rings",
    "widget.cc-windows.name": "Usage Rings",
    "widget.cc-windows.desc": "5h / weekly / monthly usage as rings",
    "widget.sys-board.name": "System Board",
    "widget.sys-board.desc": "CPU / memory / GPU VRAM and utilization dashboard rings",
    "widget.cc-subscription.name": "Plan Tier",
    "widget.cc-subscription.desc": "Current plan tier (GOAT / Pro / Max …) and the billing period end",
    "widget.cc-subscription.simToggle": "Cycle the plan tier",
    "widget.sys-gpu-line.name": "Performance",
    "widget.sys-gpu-line.desc": "GPU performance sparkline (last ~20 min)",
    "widget.cc-window-5h.name": "5h Window",
    "widget.cc-window-5h.desc": "5-hour quota window usage percent and reset time",
    "widget.cc-window-weekly.name": "Weekly Window",
    "widget.cc-window-weekly.desc": "Weekly quota window usage percent and reset time",
    "widget.cc-window-monthly.name": "Monthly Window",
    "widget.cc-window-monthly.desc": "Billing-period usage percent (used / used+remaining) and period end",
    "widget.deepseek-balance.name": "DeepSeek Balance",
    "widget.deepseek-balance.desc": "Official DeepSeek platform balance: topped-up / granted credit, today's spend as observed by this machine, and this conversation's cost (≈ = folded at the current rate)",
    "widget.deepseek-balance.simToggle": "Healthy / low / insufficient / unconfigured",
    "deepseek.title": "DeepSeek Balance",
    "deepseek.justNow": "just now",
    "deepseek.updated": "updated {ago} ago",
    "deepseek.granted": "Granted",
    "deepseek.toppedUp": "Topped up",
    "deepseek.spentToday": "Today spent",
    "deepseek.sessionSpend": "This chat",
    "deepseek.tokens": "tok",
    "deepseek.insufficient": "Insufficient",
    "deepseek.insufficientHint": "The account has no usable balance, so DeepSeek has stopped serving its API calls; it recovers after a top-up",
    "deepseek.lowHint": "Balance is below your alert threshold of {low}",
    "deepseek.spentHint": "Today's spend sums the balance drops this host sampled (the official API publishes a balance only, no usage): spend while dsh was not running is not counted, and a top-up is not counted as negative spend",
    "deepseek.estHint": "This chat's cost is folded at the rate in effect now: the session record carries no per-request timestamps, so peak and off-peak hours cannot be priced apart (hence the ≈)",
    "deepseek.unconfigured": "DEEPSEEK_API_KEY is not configured — the host auto-reads env / $DSH_HOME/.credentials.yaml / .env; effective after a restart",
    "deepseek.unauthorized": "DEEPSEEK_API_KEY was rejected (401) — check that the key is still valid",
    "deepseek.unloaded": "dsh web not restarted — waiting for the host route (auto-refresh after restart)",
    "deepseek.timeout": "The DeepSeek balance endpoint timed out; it retries automatically",
    "deepseek.unavailable": "DeepSeek balance unavailable",
    "deepseek.short.unconfigured": "No API key",
    "deepseek.short.unauthorized": "Key rejected",
    "deepseek.short.unloaded": "Host route missing",
    "deepseek.short.timeout": "Read timed out",
    "deepseek.short.unavailable": "Unavailable",
    "deepseek.short.failed": "Read failed",
    "deepseek.waiting": "Waiting for the balance…",
    "deepseek.failed": "Balance read failed ({code})",
    "card.deepseek-balance.low": "Low balance alert",
    "card.deepseek-balance.lowHint": "The big figure turns amber below this balance (red below half of it); default 10, in the account's own currency",
    "widget.github-contrib.name": "Contribution Heatmap",
    "widget.github-contrib.desc": "GitHub contribution calendar in GitHub's own five-step green. 2×2 covers ~3 months, 2×4 the last year (the window GitHub's profile header reports); reads this machine's login unless a user is set",
    "widget.github-stars.name": "Stars",
    "widget.github-stars.desc": "Repo stars with the repo name above and forks below; tap the card to cycle when several repos are watched",
    "widget.github-issues.name": "Open Issues",
    "widget.github-issues.desc": "Open issues (PRs excluded), with how many nobody has answered underneath — measured only with a token, otherwise the line says so",
    "widget.github-push.name": "Latest Push",
    "widget.github-push.desc": "How long since the last push (12s / 5m / 3h / 6d), with the newest release tag underneath",
    "widget.github-board.name": "Repo Pulse",
    "widget.github-board.desc": "2×4 board: stars / open issues / unanswered / last push side by side, with the full repo name and newest release on the title row",
    "widget.usage-mix.name": "Plan Overview",
    "widget.usage-mix.desc": "Cross-platform quota board: today's tokens first, the board's tightest occupancy as a head ring, then one row per platform (its second key pool reads Ⅱ)",
    "card.usage-mix.opencode": "OpenCode Go",
    "card.usage-mix.commandcode": "Command Code",
    "card.usage-mix.today": "Today",
    "card.usage-mix.legend": "{win} · {at}",
    "card.usage-mix.mark.Δ": "rolling",
    "card.usage-mix.mark.W": "weekly",
    "card.usage-mix.mark.M": "monthly",
    "card.usage-mix.mark.5h": "5h",
    "card.usage-mix.cfg.daily": "Show today's tokens",
    "card.usage-mix.cfg.opencode": "Show OpenCode Go (turn off once unsubscribed)",
    "card.usage-mix.cfg.commandcode": "Show Command Code",
    "widget.trajectory-stats.name": "Trajectory Share",
    "widget.trajectory-stats.desc": "The stats view of Trajectory: each lane's time and share of the window; tap to switch the figure between model and tool",
    "widget.trajectory-stats.simToggle": "Switch figure: model / tool",
    "card.trajectory-stats.cycleHint": "Click to switch the figure: model → tool",
    "card.trajectory-stats.input": "Input",
    "card.trajectory-stats.model": "Model",
    "card.trajectory-stats.tool": "Tool",
    "widget.peak-pricing-board.name": "Peak Hours Board",
    "widget.peak-pricing-board.desc": "The 2×4 peak-pricing timetable: how the rest of today bills — peak 09:00–12:00 / 14:00–18:00, off-peak otherwise, the row billing right now highlighted, plus how long until the rate flips; weekends and Chinese public holidays say why they are off-peak all day (same rule as the 2×2 Peak Pricing card; windows, zone and extra off-peak days configurable)",
    "card.peak-pricing-board.title": "Peak Hours Board",
    "card.peak-pricing-board.peak": "Peak",
    "card.peak-pricing-board.off": "Off-peak",
    "card.peak-pricing-board.until": "until",
    "card.peak-pricing-board.next": "Next",
    "card.peak-pricing-board.nextDay": "Next (tomorrow)",
    "card.peak-pricing-board.nextDayShort": "tomorrow",
    "card.peak-pricing-board.nextOff": "Back to peak",
    "card.peak-pricing-board.left": "{d} left",
    "card.peak-pricing-board.dow.0": "Sun",
    "card.peak-pricing-board.dow.1": "Mon",
    "card.peak-pricing-board.dow.2": "Tue",
    "card.peak-pricing-board.dow.3": "Wed",
    "card.peak-pricing-board.dow.4": "Thu",
    "card.peak-pricing-board.dow.5": "Fri",
    "card.peak-pricing-board.dow.6": "Sat",
    "card.peak-pricing-board.simToggle": "Peak / off-peak / holiday / weekend",
    "card.peak-pricing-board.staleHint": "The holiday table does not cover {year} (source: {source}) — weekday/weekend only. Add that year's dates under \"Extra off-peak days\".",
    "card.peak-pricing-board.weekend": "Weekend",
    "card.peak-pricing-board.holiday.newyear": "New Year's Day",
    "card.peak-pricing-board.holiday.spring": "Spring Festival",
    "card.peak-pricing-board.holiday.qingming": "Qingming",
    "card.peak-pricing-board.holiday.labour": "Labour Day",
    "card.peak-pricing-board.holiday.dragon": "Dragon Boat Festival",
    "card.peak-pricing-board.holiday.midautumn": "Mid-Autumn Festival",
    "card.peak-pricing-board.holiday.national": "National Day",
    "card.peak-pricing-board.holiday.custom": "Custom off-peak day",
    "config.peak-pricing-board.windows": "This card's windows (empty = follow the peak windows below; comma separated, max 2)",
    "config.peak-pricing-board.peakWindows": "Peak windows (Beijing time, comma separated, max 2)",
    "config.peak-pricing-board.weekendOff": "Weekends off-peak all day",
    "config.peak-pricing-board.holidayOff": "Chinese public holidays off-peak all day",
    "config.peak-pricing-board.timeZone": "Time zone",
    "config.peak-pricing-board.tz.beijing": "Beijing (UTC+8)",
    "config.peak-pricing-board.tz.local": "Local time",
    "config.peak-pricing-board.extraHolidays": "Extra off-peak days (2027-01-01 or 2027-02-05..2027-02-11)",
    "widget.goal-progress.name": "Goal Progress",
    "widget.goal-progress.desc": "The goal's lifecycle phase (active / paused / blocked / complete / no goal), then three rows: the objective, rounds / max (a goal that has not run a round says \"Not started\" — never 0 / 256) and the last change; with no goal the card stays as a quiet empty state instead of disappearing",
    "widget.goal-progress.simToggle": "Cycle no-goal / active / just-created / blocked / complete",
    "card.goal-progress.title": "Goal Progress",
    "card.goal-progress.phase.active": "Active",
    "card.goal-progress.phase.paused": "Paused",
    "card.goal-progress.phase.blocked": "Blocked",
    "card.goal-progress.phase.complete": "Complete",
    "card.goal-progress.phase.none": "No goal",
    "card.goal-progress.noGoal": "No goal in this session",
    "card.goal-progress.objective": "Goal",
    "card.goal-progress.roundsLabel": "Rounds/max",
    "card.goal-progress.rounds": "{done} / {max}",
    "card.goal-progress.roundsNotStarted": "Not started",
    "card.goal-progress.changed": "Updated",
    "card.goal-progress.ago": "{ago} ago",
    "card.goal-progress.blockedLegend": "Reason: {reason}",
    "widget.subagent.name": "Subagents",
    "widget.subagent.desc": "What this session dispatched: how many subagents, how many are resumable, and who they are",
    "card.subagent.title": "Subagents",
    "card.subagent.legendActive": "longest active {dur}",
    "card.subagent.legendEarliest": "earliest created {ago} ago",
    "card.subagent.continuable": "Continuable",
    "card.subagent.recent": "Latest",
    "card.subagent.ago": "{ago} ago",
    "widget.subagent.simToggle": "Toggle longest-active / earliest-created preview",
    "card.subagent.none": "No subagents",
    "widget.guard.name": "Permissions",
    "widget.guard.desc": "The effective permission preset — the official selector's shield plus its name (the projection already folds preset, sandbox mode and approval policy into this one value)",
    "widget.guard.simToggle": "Cycle presets",
    "card.guard.title": "Permissions",
    "card.guard.preset.readOnly": "Read Only",
    "card.guard.preset.workspaceWrite": "Workspace Write",
    "card.guard.preset.fullAccess": "Full access",
    "widget.jobs.name": "Background Jobs",
    "widget.jobs.desc": "This session’s background jobs: how many are running, the longest one, and what the newest is",
    "card.jobs.title": "Background Jobs",
    "card.jobs.legend": "longest {longest} · {total} total",
    "card.jobs.idle": "{n} finished",
    "card.jobs.longest": "Longest",
    "card.jobs.newest": "Newest",
    "card.jobs.failed": "Failed",
    "widget.jobs.simToggle": "Running / finished / empty preview",
    "widget.sys-disk.name": "Disk & Self-check",
    "widget.sys-disk.desc": "Free space per drive (bar = used, text = free), the DSH session-log footprint and how much of it was written in the last hour, and the web process's own usage — the operational risks a long-running harness actually hits",
    "widget.sys-disk.simToggle": "Preview readable / unreadable session dir",
    "card.sys-disk.title": "Disk & Self-check",
    "card.sys-disk.row": "{mount} {free} free / {total}",
    "card.sys-disk.rowShort": "{mount} {free} free",
    "card.sys-disk.logLine": "DSH session logs {size} · +{recent} files this hour",
    "card.sys-disk.procLine": "dsh web memory {rss} · CPU {cpu} · up {uptime}",
    "card.sys-disk.hidden": "{n} more drives have more room: {list}",
    "card.sys-disk.hintLog": "{files} session files in total",
    "card.sys-disk.hint": "dsh web process PID {pid} · {rss} RSS · {cpu} CPU · {uptime} up",
    "widget.window-forecast.name": "Throttle Forecast",
    "widget.window-forecast.desc": "At the current pace, will the 5h / weekly quota window hit its cap before it resets? (Quota Forecast only covers the monthly window)",
    "widget.window-forecast.simToggle": "Read later",
    "card.window-forecast.title": "Throttle Forecast",
    "card.window-forecast.win5h": "5h",
    "card.window-forecast.winWeekly": "Weekly",
    "card.window-forecast.projected": "est.",
    "card.window-forecast.fillIn": "cap in {d}",
    "card.window-forecast.noFill": "no cap · {d}",
    "card.window-forecast.resetLeft": "Quota reset",
    "widget.sys-net.name": "Network Throughput",
    "widget.sys-net.desc": "Live per-adapter receive / transmit rate (a counter delta) for this machine, plus the busiest adapter",
    "card.sys-net.title": "Network",
    "card.sys-net.busiest": "Busy",
    "card.sys-net.simToggle": "Live / idle / no sample",
    "card.sys-net.adapters": "{n} links",
    "widget.sys-power.name": "Power",
    "widget.sys-power.desc": "Whether this machine runs on battery, its charge and remaining runtime, and the active Windows power scheme",
    "card.sys-power.title": "Power",
    "card.sys-power.source.ac": "Plugged in",
    "card.sys-power.source.battery": "Battery",
    "card.sys-power.source.unknown": "Source unknown",
    "card.sys-power.desktop": "Desktop (no battery)",
    "card.sys-power.chargeUnknown": "charge unknown",
    "card.sys-power.row.left": "Left",
    "card.sys-power.row.scheme": "Power plan",
    "card.sys-power.hintUnknown": "No runtime estimate was reported, so this card omits the Left row",
    "card.sys-power.simToggle": "Cycle power states",
    "widget.sys-procs.name": "Process Memory",
    "widget.sys-procs.desc": "The top processes by working set (RSS), with the leading process's working-set bytes as the figure — which process is holding this machine's RAM while several agents or models run at once",
    "widget.sys-procs.simToggle": "Toggle many- / one-process preview",
    "card.sys-procs.title": "Process Memory",
    "widget.sys-services.name": "Local Dependencies",
    "widget.sys-services.desc": "Liveness and latency of this machine's key local endpoints (DSH web; the local model runtimes are opt-in) plus whether the proxy egress really works — a listening port is not proof. A runtime you do not run gets no row at all, so it cannot raise a false \"down\" alarm",
    "card.sys-services.title": "Local Dependencies",
    "card.sys-services.up": "up",
    "card.sys-services.down": "down",
    "card.sys-services.verdictOk": "egress ok",
    "card.sys-services.verdictFail": "no egress",
    "card.sys-services.verdictWait": "checking",
    "card.sys-services.egressOk": "egress {ms}",
    "card.sys-services.egressPort": "proxy {ms}",
    "card.sys-services.egressDetail": "egress probe failed: {error}",
    "card.sys-services.noRule": "a listening port is not an egress verdict",
    "card.sys-services.cfg.ollama": "Show Ollama (local LLM)",
    "card.sys-services.cfg.lmstudio": "Show LM Studio",
    "card.sys-services.cfg.hint": "Leave off unless you run a local model: a switched-off port gets no row, so an uninstalled runtime is not a permanent \"down\"",
    "card.sys-services.simToggle": "Cycle the preview state",
    "widget.session-cost.name": "Session Cost",
    "widget.session-cost.desc": "Folds this session's four token buckets into money using the price table, and says which table it used (official / reseller / free route / estimated)",
    "widget.session-cost.simToggle": "List rate / peak rate / no price table",
    "card.session-cost.title": "Session Cost",
    "card.session-cost.uncached": "Miss",
    "card.session-cost.read": "Hit",
    "card.session-cost.output": "Output",
    "card.session-cost.src.official": "Official rate",
    "card.session-cost.src.reseller": "Reseller rate",
    "card.session-cost.src.local": "Free route",
    "card.session-cost.src.fallback": "Estimated rate",
    "card.session-cost.src.unknown": "Source not stated",
    "card.session-cost.noTable": "No price table · tokens",
    "card.session-cost.noRoute": "No model route · tokens",
    "card.session-cost.noRule": "No rate match · tokens",
    "card.session-cost.estHint": "Estimated at the rate in effect now: the session record carries no per-request timestamps, so peak and off-peak hours cannot be priced apart (hence the ≈).",
    "widget.github-notify.name": "To Review",
    "widget.github-notify.desc": "Unread GitHub threads waiting on you: review requests, mentions and assignments, plus the newest one — needs a token or a gh login (no card at all when signed out)",
    "card.github-notify.title": "To Review",
    "card.github-notify.review": "Review requests",
    "card.github-notify.mention": "Mentions",
    "card.github-notify.assign": "Assigned",
    "card.github-notify.quiet": "Nothing waiting",
    "card.github-notify.noNewest": "Newest not reported",
    "card.github-notify.outside": "{n} more in CI / other, not in the three rows",
    "card.github-notify.reason.review_requested": "Review requested",
    "card.github-notify.reason.mention": "Mention",
    "card.github-notify.reason.assign": "Assigned",
    "card.github-notify.reason.ci_activity": "CI activity",
    "card.github-notify.reason.other": "Other",
    "card.github-notify.reason.comment": "Comment",
    "card.github-notify.reason.author": "Your thread",
    "card.github-notify.reason.state_change": "State change",
    "card.github-notify.reason.subscribed": "Subscribed",
    "card.github-notify.reason.team_mention": "Team mention",
    "card.github-notify.reason.invitation": "Invitation",
    "card.github-notify.reason.security_alert": "Security alert",
    "card.github-notify.reason.manual": "Manual",
    "sim.notify": "Unread / Empty / CI only / Thin / Signed out",
  },
}
